"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = paramsConvertTable;

/**
 * 将外部传入的查询条件，解析成dataManager能理解的table对象列表
 * @param {*} options 统一的外部入参格式
 * {
 *   mainTable: 'msgame_demo.ActivityAll',
 *   forkTableList: ['msgame_demo.TaskActivity'],
 *   objectId: 10, // getDetail才生效(实际可以复用filterCon？)
 *   filterCon: [
 *     {
 *       table: 'msgame_demo.ActivityAll',
 *       field: 'ActivityID',
 *       value: '199999',
 *       optType: '=', //=,!=, > ,>= , <, <=, %%, =%, %=, !%,
 *     },
 *     {
 *       table: 'msgame_demo.ActivityAll',
 *       field: 'ActivityName',
 *       value: '测试welkin',
 *       optType: '=', //=,!=, > ,>= , <, <=, %%, =%, %=, !%,
 *     },
 *   ],
 *   sortCon: {
 *     'msgame_demo.ActivityAll.ActivityID': 'asc',
 *     'msgame_demo.ActivityAll.ActivityName': 'desc',
 *   },
 *   fieldCon: {
 *     exclude: ['xxx.xxx.xx1', 'xxx.xxx.xx2'],
 *     include: ['xxx.xxx.xx1', 'xxx.xxx.xx2'],
 *   },
 *   pageCon: {
 *     page: 1,
 *     size: 20,
 *   },
 * }
 */
function paramsConvertTable(tableList, options) {
  // 获取单个表的数据过滤条件（映射无极api）
  (options.filterCon || []).forEach(function (item) {
    var curTable = tableList.find(function (table) {
      return table.key === item.table;
    });

    if (curTable) {
      var schemaList = curTable.schemaList || [];
      var isFloat = false;
      var findSchema = schemaList.find(function (schema) {
        return schema.id === item.field;
      });

      if (findSchema) {
        if ([100, 8, 21].indexOf(findSchema.type) > -1) {
          isFloat = true;
        }
      }

      var value = item.value;

      if (typeof value === 'string' || typeof value === 'number') {
        // 无极1.0数据过滤的字符串需要带双引号
        value = isFloat ? "".concat(value) : "\"".concat(value, "\"");
      }

      if (Array.isArray(value)) {
        value = "[".concat(value.map(function (childValue) {
          if (typeof childValue === 'string' || typeof childValue === 'number') {
            return isFloat ? "".concat(childValue) : "\"".concat(childValue, "\"");
          }

          return childValue;
        }).join(','), "]");
      }

      curTable.queryFilterList.push({
        key: item.field,
        value: value,
        optType: item.optType
      });
    }
  }); // 获取单个表的字段排序条件（映射无极api）

  var sortCon = options.sortCon || {};
  var tempObj = {};
  Object.keys(sortCon).forEach(function (key) {
    var keys = key.split('.');

    if (keys.length === 3) {
      var tableKey = "".concat(keys[0], ".").concat(keys[1]);

      if (!tempObj[tableKey]) {
        tempObj[tableKey] = {
          sort: keys[2],
          order: sortCon[key]
        };
      } else {
        tempObj[tableKey].sort += ",".concat(keys[2]);
        tempObj[tableKey].order += ",".concat(sortCon[key]);
      }
    } else {
      console.warn('无效的表字段排序条件', key);
    }
  });
  tableList.forEach(function (item) {
    if (tempObj[item.key]) {
      item.queryBaseList.push({
        key: 'sort',
        value: tempObj[item.key].sort,
        optType: '='
      });
      item.queryBaseList.push({
        key: 'order',
        value: tempObj[item.key].order,
        optType: '='
      });
    }
  }); // 获取单个表的分页控制条件（映射无极api）

  var pageCon = Object.assign({
    page: 1,
    size: 20
  }, options.pageCon || {}); // 注：目前只有主表应用此条件，子表必须尽量大，因为无极默认20条。。

  tableList.forEach(function (table) {
    var curPageCon = {
      page: 1,
      size: 200
    };

    if (table.isMain) {
      curPageCon = pageCon;
    }

    Object.keys(curPageCon).forEach(function (key) {
      table.queryBaseList.push({
        key: key,
        value: curPageCon[key],
        optType: '='
      });
    });
  });
  return tableList;
}